import React, { useEffect, useState } from 'react';
import AppToast from './AppToast';
import { consumePendingRedirectToast } from '../utils/pendingRedirectToast';

/**
 * Shows a toast from sessionStorage after a full-page redirect (e.g. custom script → /view/contact/...).
 */
export default function PendingRedirectToast() {
  const [toast, setToast] = useState({ show: false, message: '', variant: 'success' });

  useEffect(() => {
    const pending = consumePendingRedirectToast();
    if (pending?.message) {
      setToast({
        show: true,
        message: pending.message,
        variant: pending.variant || 'success',
      });
    }
  }, []);

  return (
    <AppToast
      show={toast.show}
      message={toast.message}
      variant={toast.variant}
      onClose={() => setToast((prev) => ({ ...prev, show: false }))}
    />
  );
}
